'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gsap = require('gsap');

var _three = require('three');

var THREE = _interopRequireWildcard(_three);

var _vertex = require('./vertex');

var _vertex2 = _interopRequireDefault(_vertex);

var _fragment = require('./fragment');

var _fragment2 = _interopRequireDefault(_fragment);

var _mobileAndTabletcheck = require('./mobileAndTabletcheck');

var _mobileAndTabletcheck2 = _interopRequireDefault(_mobileAndTabletcheck);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DistortedImage = function (_Component) {
  _inherits(DistortedImage, _Component);

  function DistortedImage() {
    var _temp, _this, _ret;

    _classCallCheck(this, DistortedImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      rendererDomElement: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DistortedImage.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        displacementImage = _props.displacementImage,
        image1 = _props.image1,
        image2 = _props.image2,
        intensity = _props.intensity,
        speedIn = _props.speedIn,
        speedOut = _props.speedOut,
        easing = _props.easing;

    var parent = this.refs.parent;

    var scene = new THREE.Scene();
    var camera = new THREE.OrthographicCamera(parent.offsetWidth / -2, parent.offsetWidth / 2, parent.offsetHeight / 2, parent.offsetHeight / -2, 1, 1000);

    camera.position.z = 1;

    var renderer = new THREE.WebGLRenderer({
      antialias: false
      // alpha: true
    });

    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setClearColor(0xffffff, 0.0);

    renderer.setSize(parent.offsetWidth, parent.offsetHeight);
    parent.appendChild(renderer.domElement);
    // this.setState({
    //   rendererDomElement: renderer.domElement,
    // });

    var loader = new THREE.TextureLoader();
    loader.crossOrigin = "";
    var texture1 = loader.load(image1);
    var texture2 = loader.load(image2);

    var disp = loader.load(displacementImage);
    disp.wrapS = disp.wrapT = THREE.RepeatWrapping;

    texture1.magFilter = texture2.magFilter = THREE.LinearFilter;
    texture1.minFilter = texture2.minFilter = THREE.LinearFilter;

    texture1.anisotropy = renderer.getMaxAnisotropy();
    texture2.anisotropy = renderer.getMaxAnisotropy();

    var mat = new THREE.ShaderMaterial({
      uniforms: {
        effectFactor: { type: "f", value: intensity },
        dispFactor: { type: "f", value: 0.0 },
        texture: { type: "t", value: texture1 },
        texture2: { type: "t", value: texture2 },
        disp: { type: "t", value: disp }
      },

      vertexShader: _vertex2.default,
      fragmentShader: _fragment2.default,
      transparent: true,
      opacity: 1.0
    });

    var geometry = new THREE.PlaneBufferGeometry(parent.offsetWidth, parent.offsetHeight, 1);
    var object = new THREE.Mesh(geometry, mat);
    scene.add(object);

    // ---
    var addEvents = function addEvents() {
      var evtIn = "mouseenter";
      var evtOut = "mouseleave";
      if ((0, _mobileAndTabletcheck2.default)()) {
        evtIn = "touchstart";
        evtOut = "touchend";
      }
      parent.addEventListener(evtIn, function (e) {
        _gsap.TweenMax.to(mat.uniforms.dispFactor, speedIn, {
          value: 1,
          ease: easing
        });
      });

      parent.addEventListener(evtOut, function (e) {
        _gsap.TweenMax.to(mat.uniforms.dispFactor, speedOut, {
          value: 0,
          ease: easing
        });
      });
    };

    addEvents();

    window.addEventListener("resize", function (e) {
      renderer.setSize(parent.offsetWidth, parent.offsetHeight);
    });

    this.next = function () {
      _gsap.TweenMax.to(mat.uniforms.dispFactor, speedIn, {
        value: 1,
        ease: easing
      });
    };

    this.previous = function () {
      _gsap.TweenMax.to(mat.uniforms.dispFactor, speedOut, {
        value: 0,
        ease: easing
      });
    };

    var animate = function animate() {
      requestAnimationFrame(animate);

      renderer.render(scene, camera);
    };
    animate();
  };

  DistortedImage.prototype.render = function render() {
    var _props2 = this.props,
        image1 = _props2.image1,
        image2 = _props2.image2,
        style = _props2.style,
        children = _props2.children;
    var rendererDomElement = this.state.rendererDomElement;

    return _react2.default.createElement(
      'div',
      { ref: 'parent', style: _extends({}, style, { position: 'relative' }) },
      _react2.default.createElement(
        'div',
        { style: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100% ' } },
        children
      ),
      _react2.default.createElement('img', { src: image1, alt: '', style: { display: 'none' } }),
      _react2.default.createElement('img', { src: image2, alt: '', style: { display: 'none' } })
    );
  };

  return DistortedImage;
}(_react.Component);

DistortedImage.propTypes = process.env.NODE_ENV !== "production" ? {
  image1: _propTypes2.default.string.isRequired,
  image2: _propTypes2.default.string.isRequired,
  displacementImage: _propTypes2.default.string.isRequired,
  intensity: _propTypes2.default.number,
  speedIn: _propTypes2.default.number,
  speedOut: _propTypes2.default.number,
  hovering: _propTypes2.default.bool,
  easing: _propTypes2.default.object
} : {};
DistortedImage.defaultProps = {
  intensity: 1,
  speedIn: 1.6,
  speedOut: 1.2,
  easing: _gsap.Expo.easeOut
};

exports.default = DistortedImage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-distortion-image/lib/index.js
 ** module id = 446
 ** module chunks = 0
 **/